import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function TimeSquareIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.034 14.401C15.894 14.636 15.645 14.767 15.389 14.767C15.259 14.767 15.126 14.733 15.006 14.662L11.615 12.639C11.388 12.504 11.249 12.258 11.249 11.995V7.633C11.249 7.219 11.585 6.883 11.999 6.883C12.413 6.883 12.749 7.219 12.749 7.633V11.569L15.774 13.373C16.13 13.586 16.246 14.046 16.034 14.401ZM12 2.25C4.801 2.25 2.25 4.801 2.25 12C2.25 19.198 4.801 21.75 12 21.75C19.199 21.75 21.75 19.198 21.75 12C21.75 4.801 19.199 2.25 12 2.25Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
